import React from 'react';

const RecommendationsSection = () => {
  return (
    <section id="recommendations">
      <div className="container">
        <div className="section-label">04 — Recommendations</div>
        <div className="recommendations-list reveal">
          <div className="recommendation-item">
            <p className="recommendation-name">Gary Myers</p>
            <p className="recommendation-title">Software Engineer Architect</p>
            <p className="recommendation-copy">
              Bill was a great manager, probably the best I&apos;ve had in my career. He had an open (and a
              closed) door policy for feedback and conversation. I tried not to bug him too much because he
              was always working extremely hard on the mountain of tasks he had, but never once did he turn
              me away.
            </p>
            <p className="recommendation-copy">
              Beyond being a great manager he was also an amazing collaborator on software projects. I thought
              I was good with JavaScript until I met Bill. His ability to weave new functionality into old
              systems that predated both of us was beyond measure, and saved our bacon on more than one occasion.
            </p>
            <p className="recommendation-copy">
              I would be excited to work with Bill again, as either a manager or software developers on the same team.
            </p>
          </div>

          <div className="recommendation-item">
            <p className="recommendation-name">Mark Allen</p>
            <p className="recommendation-title">Financial Senior Software Engineer Banking, Fintechs, Payment cards.</p>
            <p className="recommendation-copy">
              I had the pleasure of working with Bill on multiple projects and found it quite simply, a breeze.
              His skills in visual and user interfacing was an outstanding help to all the projects. When passing
              developed assets to him, I knew he could grasp the concepts and implement into the code base efficiently
              and effectively. To add to his creativity, he could stand alone with critical and deep development.
              Through my years in the industry, it has been rare to find his skills and qualities in one person.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecommendationsSection;

